import React from 'react';
import classnames from 'classnames';
import { forceRedirectToPath, isRedirectWrapperStateExists } from 'swag-common/business-logic/redirect-wrapper-state';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './not-found.scss';
import { BACK_LABEL } from './labels';
const NotFound = ({
  className,
  location
}) => {
  const {
    action,
    state,
    pathname
  } = location || {};
  if (isRedirectWrapperStateExists(state, action)) {
    forceRedirectToPath(pathname);
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, className)
  }, /*#__PURE__*/React.createElement("h1", null, "Page not found"), /*#__PURE__*/React.createElement("div", {
    className: classes.notFound
  }), /*#__PURE__*/React.createElement("h6", null, "404"), /*#__PURE__*/React.createElement("p", null, "The page you are looking for doesn't exist."), /*#__PURE__*/React.createElement("p", null, "Go back to ", /*#__PURE__*/React.createElement("a", {
    href: APP_ROUTES.HOME
  }, BACK_LABEL)));
};
export default NotFound;